import React, { useEffect, useState } from "react";
import Select from "react-select";
import ApiService from "../../Core/Service/ApiService";
import { useNavigate, useParams } from "react-router-dom";
import { LondonDate, capitalizeFirstLetter, getImageUrl, validateForm } from "../../Utils/utils";
import { toast } from "react-toastify";
import LoadingIndicator from "../../Components/LoadingIndicator/LoadingIndicator";
import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle, MDBCheckbox, MDBCol, MDBInput, MDBRow, MDBSpinner } from "mdb-react-ui-kit";
import { WeekDays } from "../../Constants/constants";
import DateTimePicker from "react-datetime-picker";
import { useContext } from "react";
import CmsContext from "../../Context/CmsContext";

const BranchEdit = React.memo(props => {
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [formData, setFormData] = useState({});
    const params = useParams();
    const navigate = useNavigate();
    let rules = {
        site_name: {
            required: 'string'
        },
        trading_name: {
            required: 'string'
        }
    }
    const [inputErrors, setInputErrors] = useState({});
    const cmsContext = useContext(CmsContext);

    useEffect(() => {
        cmsContext.setBreadcrumb([
            { title: cmsContext.currMainMenu?.label ?? ''},
            { title: cmsContext.currSubMenu?.label ?? ''},
            { title: capitalizeFirstLetter(params.action) },
        ])
    }, [])

    const loadData = async () => {
        setLoading(true);

        if(params.action == 'edit' || params.action == 'copy') {
            let response = await ApiService.get(`/branches/show/${params.id}`);
            const branch = response.data.branch;
            delete branch.id;
            setFormData({...branch});
        }

        setLoading(false);
    }

    useEffect(() => {
        loadData()
    }, [params.action])

    useEffect(()=>{
        const ret = validateForm(formData, rules);
        setInputErrors(ret.errors);
    }, [formData])

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }
    const handleSave = () => {
        const ret = validateForm(formData, rules);
        if(ret.result) {
            setInputErrors({});
            setSaving(true);

            const url = (params.action == 'edit') ? `/branches/save/${params.id}` : '/branches/create';
            ApiService.post(url, formData).then(response => {
                navigate(-1);            
            })
            .finally(()=>{
                setSaving(false);
            })
    
        } else {
            setInputErrors(ret.errors)
        }
    }

    return (
    <div className="branch-edit mx-auto p-4 w-fit-content">
        <MDBCard>
            <MDBCardHeader>
                <MDBCardTitle>Main Information</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <MDBRow>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label className="required">Site Name:</label>
                        <MDBInput name='site_name' value={formData.site_name ?? ''} onChange={handleInputChange} />
                        {inputErrors?.site_name && <div className="error">{inputErrors.site_name}</div>}
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label className="required">Trading Name:</label>
                        <MDBInput name='trading_name' value={formData.trading_name ?? ''} onChange={handleInputChange} />
                        {inputErrors?.trading_name && <div className="error">{inputErrors.trading_name}</div>}
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Email:</label>
                        <MDBInput name='email' value={formData.email ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Telephone:</label>
                        <MDBInput name='telephone' value={formData.telephone ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Fax:</label>
                        <MDBInput name='fax' value={formData.fax ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>WhatsApp Number:</label>
                        <MDBInput name='whatsapp_number' value={formData.whatsapp_number ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Post Code:</label>
                        <MDBInput name='post_code' value={formData.post_code ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Address1:</label>
                        <MDBInput name='address1' value={formData.address1 ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Address2:</label>
                        <MDBInput name='address2' value={formData.address2 ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Address3:</label>
                        <MDBInput name='address3' value={formData.address3 ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Depot Plan:</label>
                        <MDBInput name='depot_plan' value={formData.depot_plan ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Depot Location:</label>
                        <MDBInput name='depot_location' value={formData.depot_location ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Geo Latitude:</label>
                        <MDBInput name='geo_latitude' value={formData.geo_latitude ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4">
                        <label>Geo Longitude:</label>
                        <MDBInput name='geo_longitude' value={formData.geo_longitude ?? ''} onChange={handleInputChange} />
                    </MDBCol>
                    <MDBCol size={6} lg={4} xl={3} className="mt-4 d-flex align-items-end">
                        <MDBCheckbox
                            name='active'
                            label='Active (uncheck for info only)'
                            checked={formData.active === undefined ? true : Number(formData.active) === 1}
                            onChange={e => setFormData({...formData, active: e.target.checked ? 1 : 0})}
                        />
                    </MDBCol>
                </MDBRow>
            </MDBCardBody>
        </MDBCard>

        <MDBCard className="mt-4">
            <MDBCardHeader>
                <MDBCardTitle>Opening Time</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <MDBRow>
                    {WeekDays.map((wd, index)=>(
                    <MDBCol size={6} lg={3} xl={3} key={index} className="mb-4">
                        <label>{wd.label}:</label>
                        <div className="d-flex align-items-center">
                            <label style={{width: 100}}>Open:</label>
                            <MDBInput name={`${wd.id}_open`} value={formData[`${wd.id}_open`] ?? ''} onChange={handleInputChange} />
                        </div>
                        <div className="d-flex align-items-center mt-2">
                            <label style={{width: 100}}>Close:</label>
                            <MDBInput name={`${wd.id}_close`} value={formData[`${wd.id}_close`] ?? ''} onChange={handleInputChange} />
                        </div>
                    </MDBCol>
                    ))}
                </MDBRow>
            </MDBCardBody>
        </MDBCard>

        <div className="d-flex justify-content-end mt-4">
            <MDBBtn color="default" onClick={e=>navigate(-1)}>Back</MDBBtn>
            <MDBBtn className="united-cms-primary-btn ms-4" onClick={handleSave} disabled={saving}>
                {saving && <MDBSpinner size="sm" className="me-1" />}
                Save
            </MDBBtn>
        </div>

        <LoadingIndicator show={loading} />
    </div>
    )
})

export default BranchEdit;